import React from "react";
import { UserAuth } from './context/AuthContext'
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";


const Logo = require('./assets/Poom.png');
function Navbar() {
  const { logout } = UserAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
  try {
    await logout();
    navigate('/');
    console.log('You are logged out');
  } catch (e) {
    console.log(e.message);
  }
};

  return (
    <nav className="flex items-center justify-around flex-wrap bg-[#ffc700] p-10">
      <div className="flex flex-shrink-0 text-white mr-6">
      <Link to='/account'>
        <img src={Logo} alt="Poom pic"/>
      </Link>
      </div>
      <div className="block lg:flex lg:w-auto">
        <div className="flex">
          <div className="dropdown relative">
            <button
              className="
                dropdown-toggle
                px-6
                py-2.5
                bg-white
                text-black
                font-bold
                text-xs
                leading-tight
                uppercase
                rounded
                shadow-md
                hover:bg-white hover:shadow-lg
                focus:bg-white focus:shadow-lg focus:outline-none focus:ring-0
                active:bg-white active:shadow-lg active:text-white
                transition
                duration-150
                ease-in-out
                flex
                items-center
                whitespace-nowrap
              "
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Navigation
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="caret-down"
                class="w-2 ml-2"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="currentColor"
                  d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                ></path>
              </svg>
            </button>
            <ul
              className="
                dropdown-menu
                min-w-max
                absolute
                hidden
                bg-white
                text-base
                z-50
                float-left
                py-2
                list-none
                text-left
                rounded-lg
                shadow-lg
                mt-1
                hidden
                m-0
                bg-clip-padding
                border-none
              "
              aria-labelledby="dropdownMenuButton1"
            >
              <li>
                <a
                  className="
                    dropdown-item
                    text-sm
                    py-2
                    px-4
                    font-bold
                    block
                    w-full
                    whitespace-nowrap
                    bg-transparent
                    text-gray-700
                    hover:bg-gray-100
                  "
                  href={'/users'}
                  >Users</a
                >
              </li>
              <li>
                <a
                  className="
                    dropdown-item
                    text-sm
                    py-2
                    px-4
                    font-bold
                    block
                    w-full
                    whitespace-nowrap
                    bg-transparent
                    text-gray-700
                    hover:bg-gray-100
                  "
                  href={`/reports`}
                  >Reports</a
                >
              </li>
              <li>
                <button
                  className="
                    dropdown-item
                    text-sm
                    py-2
                    px-4
                    font-bold
                    block
                    w-full
                    whitespace-nowrap
                    bg-transparent
                    text-gray-700
                    hover:bg-gray-100
                  "
                  onClick={handleLogout}
                  >Logout</button
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar;
